module.exports = __webpack_public_path__ + "static/media/fix_cash500.a5731388.png";